import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/powered-by-contigo.png")